import React from 'react';
import { useField } from 'formik';
import {
  ToggleButtonGroup as MUIToggleButtonGroup,
  ToggleButtonGroupProps as MUIToggleButtonGroupProps,
  FormControl, FormHelperText, InputLabel
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';


export type ToggleButtonGroupProps = MUIToggleButtonGroupProps & {
  name: string;
  label?: string;
  nullable?: boolean;
  fullWidth?: boolean;
};


const useStyles = makeStyles()(theme => ({
  error: {
    '& button': {
      borderColor: theme.palette.error.main,
      color: theme.palette.error.main,
    }
  }
}));


export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({ name, nullable, fullWidth, ...props }) => {
  const [ field, meta ] = useField(name);
  const { classes } = useStyles();
  const { onChange } = field;
  const helperText = meta.error;
  const hasError = Boolean(helperText);

  const handleChange = React.useCallback((e: React.MouseEvent<HTMLElement, MouseEvent>, value) => {
    if (!nullable && !value) {
      return;
    }
    onChange({
      target: {
        name,
        value,
      }
    });
  }, [ onChange, name, nullable ]);

  const labelComponent = (props.label ? (
    <InputLabel htmlFor={name} error={hasError}>
      {props.label}
    </InputLabel>
  )
    :
    null
  );

  return (
    <FormControl error={hasError} component="div" fullWidth={fullWidth}>
      {labelComponent}
      <MUIToggleButtonGroup
        className={hasError ? classes.error : undefined}
        onChange={handleChange}
        value={field.value}
        id={name}
        {...props}
      />
      {helperText && (
        <FormHelperText id={`${name}-helper`} component="div" dangerouslySetInnerHTML={{ __html: helperText }} />
      )}
    </FormControl>
  );
};
